export default __webpack_public_path__ + "media/waiting-room-about-ms-for-startups.b3a06796.webp";